import React, { useState, useContext, useEffect } from "react";
import { Route, BrowserRouter as RouterProvider, Routes } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Sidebar from "../components/Sidebar/Sidebar";
import RightSidebar from "../components/Sidebar/RightSidebar";
import Header from "../components/Header";
import Webex from "../pages/Webex/Webex";
import Certificats from "../pages/Certificats/Certificats";
import EquipementCisco from "../pages/Equipements/Cisco/EquipementCisco";
import EquipementPoly from "../pages/Equipements/Poly/EquipementPoly";
import EquipementBarco from "../pages/Equipements/Barco/EquipementBarco";
import EquipementEvoko from "../pages/Equipements/Evoko/EquipementEvoko";
import AmpTable from "../pages/AMP/AmpTable";
import Incidents from "../pages/Incidents/Incidents";
import AgentInsight from "../pages/AgentInsight/AgentInsight";
import Reporting from "../pages/Reporting/Reporting";
import AmpEvents from "../pages/AMP/AmpEvents";
import Licence from "../pages/Firewall/Licence";
import FirewallPalo from "../pages/Firewall/Palo/FirewallPalo";
import FirewallCisco from "../pages/Firewall/Cisco/FirewallCisco";
import FirewallForti from "../pages/Firewall/Forti/FirewallForti";
import Home from "../pages/Home";
import Umbrella from "../pages/Umbrella/Umbrella";
import Meraki from "../pages/Meraki/Meraki";
import Auvik from "../pages/Auvik/Auvik";
import User from "../pages/Users/User";
import SmartAccount from "../pages/SmartAccount/SmartAccount";
import Visio from "../pages/Visio/Visio";
import PageTitle from "./PageTitle";
import FileManager from "../pages/FileManager/FileManager";
import Microsoft from "../pages/Microsoft/Microsoft";
import IoT from "../pages/IoT/IoT";
import Error404 from "../pages/Error404";
import MerakiDevice from "../pages/Meraki/MerakiDevice";
import AuvikDevice from "../pages/Auvik/AuvikDevice";
import InterfaceAuvik from "../pages/Auvik/InterfaceAuvik";
import Contract from "../pages/Contract/Contract";
import Subscription from "../pages/Subscription/Subscription";
import AuvikAlerts from "../pages/Auvik/AuvikAlerts";
import MerakiLicences from "../pages/Meraki/MerakiLicences";
import TimelineEcp from "../pages/Timeline/TimelineEcp";
import StatisticsWebex from "../pages/Webex/Statistics/StatisticsWebex";
import Parking from "../pages/Parking/Parking";
import Logs from "../pages/Logs/Logs";
import SentinelOne from "../pages/SentinelOne/SentinelOne";
import Securonix from "../pages/Securonix/Securonix";
import Cato from "../pages/Cato/Cato";
import EquipementHp from "../pages/Equipements/Hp/EquipementHp";
import EquipementLenovo from "../pages/Equipements/Lenovo/EquipementLenovo";
import Ielo from "../pages/Ielo/Ielo";
import Scan from "../pages/Scan/Scan";
import Ubiquiti from "../pages/Ubiquiti/Ubiquiti";

export default function RouterEcp() {
    const [sideOpen, setSideOpen] = useState(false);
    const [rightSideOpen, setRightSideOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [entrepriseName, setEntrepriseName] = useState("");
    const { user, entrepriseRoles } = useContext(AuthContext);

    useEffect(() => {
        if (user?.holdingName || user?.entrepriseName) {
            setEntrepriseName(user.holdingName || user.entrepriseName);
        }
    }, [user]);

    const toggleRightSidebar = () => {
        if (!rightSideOpen) {
            setSideOpen(false);
        }
        setIsExpanded(false);
        setRightSideOpen(!rightSideOpen);
    };

    const handleSetSideOpen = (value) => {
        const newState = typeof value === 'function' ? value(sideOpen) : value;

        setSideOpen(newState);

        if (newState === true) {
            setRightSideOpen(false);
            setIsExpanded(false);
        }
    };

    return (
        <RouterProvider
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Sidebar sideOpen={sideOpen} setSideOpen={handleSetSideOpen} setEntrepriseName={setEntrepriseName} />
            {(user?.roles.includes("ROLE_SUPERADMIN") || user?.roles.includes("ROLE_COMMERCIAL")) && (
                <RightSidebar
                    isOpen={rightSideOpen}
                    onClose={() => { setRightSideOpen(false); setIsExpanded(false); }}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                    isLeftSidebarOpen={sideOpen}
                />
            )}
            <div className={`container ${sideOpen ? "container-open" : ""} ${rightSideOpen ? "container-shrink" : ""}`}>
                <Header sideOpen={sideOpen} toggleRightSidebar={toggleRightSidebar} />
                <article className="page">
                    <PageTitle entrepriseName={entrepriseName} />
                    <Routes>
                        <Route exact path="/" element={<Home />} />
                        {entrepriseRoles.includes("ROLE_INCIDENT") && (
                            <Route exact path="/tickets" element={<Incidents />} />
                        )}
                        {entrepriseRoles.includes("ROLE_EQUIPEMENT") && (
                            <Route exact path="/equipements/cisco" element={<EquipementCisco />} />
                        )}
                        {entrepriseRoles.includes("ROLE_POLY") && (
                            <Route exact path="/equipements/poly" element={<EquipementPoly />} />
                        )}
                        {entrepriseRoles.includes("ROLE_EVOKO") && (
                            <Route exact path="/equipements/evoko" element={<EquipementEvoko />} />
                        )}
                        {entrepriseRoles.includes("ROLE_BARCO") && (
                            <Route exact path="/equipements/barco" element={<EquipementBarco />} />
                        )}
                        {entrepriseRoles.includes("ROLE_HP") && (
                            <Route exact path="/equipements/hp" element={<EquipementHp />} />
                        )}
                        {entrepriseRoles.includes("ROLE_LENOVO") && (
                            <Route exact path="/equipements/lenovo" element={<EquipementLenovo />} />
                        )}
                        {entrepriseRoles.includes("ROLE_CONTRACT") && (
                            <Route exact path="/smartnet" element={<Contract />} />
                        )}
                        {entrepriseRoles.includes("ROLE_AMP") && (
                            <Route
                                exact
                                path="/secure_endpoint/equipement"
                                element={<AmpTable />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_SENTINELONE") && (
                            <Route
                                exact
                                path="/sentinelone"
                                element={<SentinelOne />} />
                        )}
                        {entrepriseRoles.includes("ROLE_SECURONIX") && (
                            <Route
                                exact
                                path="/securonix"
                                element={<Securonix />} />
                        )}
                        {entrepriseRoles.includes("ROLE_CATO") && (
                            <Route
                                exact
                                path="/cato"
                                element={<Cato />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_AMP") && (
                            <Route
                                exact
                                path="/secure_endpoint/events"
                                element={<AmpEvents />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_CERTIFICATS") && (
                            <Route
                                exact
                                path="/certificats"
                                element={<Certificats />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_WEBEX") && (
                            <Route exact path="/webex" element={<Webex />} />
                        )}
                        {entrepriseRoles.includes("ROLE_ANALYTICS") && (
                            <Route exact path="/hardware" element={<Reporting visio={false} firewall={false}/>}/>
                        )}
                        {entrepriseRoles.includes("ROLE_ANALYTICS") && (
                            <Route exact path="/hardware_visio" element={<Reporting visio={true} firewall={false}/>}/>
                        )}
                        {entrepriseRoles.includes("ROLE_ANALYTICS") && (
                            <Route exact path="/hardware_firewall" element={<Reporting visio={false} firewall={true}/>}/>
                        )}
                        {entrepriseRoles.includes("ROLE_PALO") && (
                            <Route
                                exact
                                path="/licences/palo"
                                element={<Licence />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_PALO") && (
                            <Route
                                exact
                                path="/firewall/palo"
                                element={<FirewallPalo />}
                            />
                        )}
                        {user.roles.includes("ROLE_SUPERADMIN") && (
                            <Route
                                exact
                                path="/firewall/cisco"
                                element={<FirewallCisco />}
                            />
                        )}
                        {user.roles.includes("ROLE_SUPERADMIN") && (
                            <Route
                                exact
                                path="/firewall/forti"
                                element={<FirewallForti />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_UMBRELLA") && (
                            <Route exact path="/umbrella" element={<Umbrella />} />
                        )}
                        {entrepriseRoles.includes("ROLE_MERAKI") && (
                            <Route exact path="/meraki" element={<Meraki />} />
                        )}
                        {entrepriseRoles.includes("ROLE_MERAKI") && (
                            <Route
                                exact
                                path="/meraki/:networkId"
                                element={<MerakiDevice />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_MERAKI") && (
                            <Route
                                exact
                                path="/meraki/licenses"
                                element={<MerakiLicences />}
                            />
                        )}
                        {!user.roles.includes("ROLE_SSO") && (
                            <Route exact path="/users" element={<User />} />
                        )}
                        {entrepriseRoles.includes("ROLE_SMARTACCOUNT") && (
                            <Route
                                exact
                                path="/smart_account"
                                element={<SmartAccount />}
                            />
                        )}
                        {(entrepriseRoles.includes("ROLE_WEBEX") ||
                            entrepriseRoles.includes("ROLE_POLY")) && (
                                <Route
                                    exact
                                    path="/visio"
                                    element={<EquipementCisco visio={true} />}
                                />
                            )}
                        <Route
                            exact
                            path="/files_manager"
                            element={<FileManager />}
                        />
                        {entrepriseRoles.includes("ROLE_0365") && (
                            <Route exact path="/microsoft" element={<Microsoft />} />
                        )}
                        {(entrepriseRoles.includes("ROLE_WEBEX") ||
                            entrepriseRoles.includes("ROLE_MERAKI")) && (
                                <Route exact path="/IoT" element={<IoT />} />
                            )}
                        {entrepriseRoles.includes("ROLE_AUVIK") && (
                            <Route exact path="/auvik" element={<Auvik />} />
                        )}
                        {entrepriseRoles.includes("ROLE_AUVIK") && (
                            <Route
                                exact
                                path="/auvik/:tenantId"
                                element={<AuvikDevice />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_AUVIK") && (
                            <Route
                                exact
                                path="/auvik/:tenantId/alerts"
                                element={<AuvikAlerts />}
                            />
                        )}
                        {entrepriseRoles.includes("ROLE_AUVIK") && (
                            <Route
                                exact
                                path="/auvik/:tenantId/:interfaceId"
                                element={<InterfaceAuvik />}
                            />
                        )}
                        <Route
                            exact
                            path="/timeline"
                            element={<TimelineEcp />}
                        />
                        {entrepriseRoles.includes("ROLE_WEBEX_CALLING") && (
                            <Route
                                exact
                                path="/statistics"
                                element={<StatisticsWebex />}
                            />
                        )}
                        {user.roles.includes("ROLE_PARKING") && (
                            <Route
                                exact
                                path="/parking"
                                element={<Parking />}
                            />
                        )}
                         {entrepriseRoles.includes("ROLE_SCAN") && (
                            <Route
                                exact
                                path="/dast"
                                element={<Scan />}
                            />
                        )}
                        {user.roles.includes("ROLE_SUPERADMIN") && (
                            <Route
                                exact
                                path="/agentinsight"
                                element={<AgentInsight />} />
                        )}
                        {user.roles.includes("ROLE_SUPERADMIN") && (
                            <Route
                                exact
                                path="/logs"
                                element={<Logs />} />
                        )}
                        {entrepriseRoles.includes("ROLE_SUBSCRIPTION") && (
                            <Route exact path="/subscription" element={<Subscription />} />
                        )}
                        {entrepriseRoles.includes("ROLE_IELO") && (
                            <Route exact path="/liaisonethernet" element={<Ielo />} />
                        )}
                        {entrepriseRoles.includes("ROLE_UBIQUITI") && (
                            <Route exact path="/ubiquiti" element={<Ubiquiti />} />
                        )}
                        <Route path="/*" element={<Error404 />} />
                    </Routes>
                </article>
            </div>
        </RouterProvider>
    );
}
